import { render, staticRenderFns } from "./Historico.vue?vue&type=template&id=004d1be2&scoped=true"
import script from "./Historico.vue?vue&type=script&lang=js"
export * from "./Historico.vue?vue&type=script&lang=js"
import style0 from "./Historico.vue?vue&type=style&index=0&id=004d1be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d1be2",
  null
  
)

export default component.exports